import { Field, reduxForm } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import * as $ from 'jquery';
import { Select, DatePicker, Input } from '../../../../itrust_common/components/form';
import { formatPhoneNumber, getCustomLabel, getShortName } from '../../../../itrust_common/components/HelperFunctions';
import { orderEdit, orderLoad, orderUpdate } from '../../../../redux/actions/order/orderActions';
import { tabChange } from '../../../../itrust_common/redux/actions/otherActions';
import { required } from '../../../../itrust_common/components/form/FormValidations';
import OrderInsurancePayer from './OrderInsurancePayer';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import RPASubmitHistory from '../../../../containers/authorised/addOns/rpa/vision_insurance/eligibilityVerify/RPASubmitHistory';
import { useEffect, useState } from 'react';
import { staffsLoad } from '../../../../redux/actions/staffActions';
import { getInsuranceLabel } from '../claimFormDropdownUtils';

let timeout = null;
function OrderHeaderForm(props) {
  const {
    defaultVisible,
    handleSubmit,
    selectedOrderId,
    providers,
    order,
    currentUser,
    visionInsuranceTemplate,
    medicalInsuranceTemplate,
    orderStaffId,
    activeTab,
    claimFormData,
    storeDefaultProviderId,
    allStaff,
    transactionNumberConfig,
  } = props;
  const showTransactionNumber = Boolean(transactionNumberConfig?.enabled);
  const isTransactionNumberRequired = Boolean(
    transactionNumberConfig?.enabled && transactionNumberConfig?.required,
  );
  const hasClaimForm = (order.orders_insurances_attributes || []).some(
    (item) => item.claim_form_id || item.visionary_insurance_claim_form_id,
  )
  const noShowInsuranceFields = ["eyemed"].includes(order.vision_insurance_service?.service)
  const showInsuranceFields = order.vision_insurance_service?.service
    ? (hasClaimForm && !noShowInsuranceFields)
    : hasClaimForm
  const isProcedureExists = order?.procedures_attributes?.length > 0
  const [priorAuthValues, setPriorAuthValues] = useState({})
  const dispatch = useDispatch()

  const priorAuthSyncKey = (order.orders_insurances_attributes || [])
    .map((insurance) => `${insurance.id}:${insurance.prior_authorization_number || ''}`)
    .join('|')

  useEffect(() => {
    const values = {}
    ;(order.orders_insurances_attributes || []).forEach((insurance) => {
      values[insurance.id] = insurance.prior_authorization_number || ''
    })
    setPriorAuthValues(values)
  }, [order.id, priorAuthSyncKey])

  useEffect(() => {
    if (!orderStaffId && storeDefaultProviderId) {
      dispatch(orderUpdate({ id: props.order.id, staff_id: props.storeDefaultProviderId }, { include: '*' }))
    }
  }, [])
  const storeId = order.store_id

  useEffect(() => {
      dispatch(staffsLoad({ rpp: 9999, filter: { selected_store: storeId } }))
  }, [])

  const handleOrderEdit = (id) => {
    dispatch(tabChange({ order: 1 }))
    dispatch(orderEdit(id));
    dispatch(orderLoad(id, { include: '*' }));
  }

  const handleOrderUpdate = (data) => {
    dispatch(
      orderUpdate(
        {
          id: order.id,
          staff_id: order.staff_id,
          order_date: order.order_date,
          promised_date: order.promised_date,
          ...data,
        },
        { include: '*' }
      )
    );
  }

  const handlePriorAuthChange = (insuranceId, value) => {
    setPriorAuthValues((prev) => ({ ...prev, [insuranceId]: value }))
  }

  const handlePriorAuthSave = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const orders_insurances_attributes = (order.orders_insurances_attributes || []).map((insurance) => ({
      id: insurance.id,
      prior_authorization_number: priorAuthValues[insurance.id] || '',
    }));
    dispatch(orderUpdate({ id: order.id, orders_insurances_attributes }, { include: '*' }));

    if (e && e.target) {
      const $dropdownMenu = $(e.target).closest('.dropdown-menu');
      $dropdownMenu.removeClass('show');
      $dropdownMenu.closest('.dropdown').find('[data-toggle="dropdown"]').attr('aria-expanded', 'false');
    } else {
      $('.dropdown-menu.show').removeClass('show');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="panel-group" id="accordion">
        <div className="panel panel-default">
          <div id="collapseOne" className={`panel-collapse collapse ${defaultVisible ? 'show' : ''}`}>
            <div className="panel-body">
              <div className="bg-white d-flex rounded shadow-sm my-5">
                <div className="border-right border-light text-center p-5">
                  {getShortName(order.patient_attributes, 'mr-5 width-6 height-6', 'mr-5 width-6 height-6 font-size-40 ')}
                  <h5 className="mt-2 text-nowrap">
                    <Link to={`/patients/${order.patient_attributes?.id}/overview`} className="btn-link" onClick={() => $('#orderForm-modal').modal('hide')}>{order.patient_attributes?.name}</Link>
                  </h5>
                  {order?.patient_attributes?.nickname && (
                    <h6 className='py-1'>"{order?.patient_attributes?.nickname}"</h6>
                  )}   
                </div>
                <div className="p-lg-6 p-2">
                  <div>
                    <span className="text-nowrap">DOB & Age:</span>
                    <span className="text-muted pl-3 text-nowrap">
                      <DateFormatView date={order.patient_attributes?.date_of_birth} />| {order.patient_attributes?.age}</span>
                  </div>
                  <div>
                    <span>Phone:</span>
                    <span className="text-muted text-muted pl-3 text-nowrap">{formatPhoneNumber(order.patient_attributes?.cell_phone)}</span>
                  </div>
                  <div>
                    <span>Email:</span>
                    <span className="text-muted text-muted pl-3 text-nowrap">{order.patient_attributes?.email}</span>
                  </div>
                  <div>
                    <span className="text-nowrap">{visionInsuranceTemplate && getCustomLabel(visionInsuranceTemplate, 'insurance')}:</span>
                    <span className="text-muted text-muted pl-3">
                      {order.patient_attributes?.patient_vision_insurance && order.patient_attributes?.patient_vision_insurance.insurance_name}
                      {order.patient_attributes?.vision_insurance_plan_name && ` | ${order.patient_attributes?.vision_insurance_plan_name}`}
                    </span>
                  </div>
                  <div>
                    <span className="text-nowrap">{medicalInsuranceTemplate && getCustomLabel(medicalInsuranceTemplate, 'insurance')} :</span>
                    <span className="text-muted text-muted pl-3">
                    {order.patient_attributes?.patient_medical_insurance && order.patient_attributes?.patient_medical_insurance.insurance_name}
                      {order.patient_attributes?.medical_insurance_plan_name && ` | ${order.patient_attributes?.medical_insurance_plan_name}`}
                    </span>
                  </div>
                </div>
                <div className="border-left border-light py-lg-4 py-2 px-lg-7 px-2 w-100">
                  <div className="row">
                    <div className="col-2 pr-0">
                      <Field
                        name="staff_id"
                        valueField="id"
                        textField="name"
                        data={providers}
                        label="Created By"
                        component={Select}
                        supportAutoComplete={true}
                        placeholder={!orderStaffId && 'Select Provider'}
                        textFieldValue={order.staff_attributes?.name ? `${order.staff_attributes?.name} (Archived)` : ''}
                        wrapperClasses={`${(currentUser.role === 'non_admin' || currentUser.role === 'admin') && 'disabled'} form-group mb-0`}
                      />
                    </div>
                    {currentUser.role !== 'non_admin' &&
                    <div className="col-2 pr-0">
                      <Field name='order_date' label="Order Date" validate={[required]} component={DatePicker} wrapperClasses='form-group mb-0' />
                    </div>
                    }
                    <div className="col-2 pr-0">
                      <div className="form-group">
                        <label htmlFor="orderpleFormControlSelect2">Order Selection </label>
                        <select className="form-control" value={selectedOrderId} id="orderpleFormControlSelect2" onChange={(e) => handleOrderEdit(e.target.value)} >
                          {order.all_orders && order.all_orders.map((order) =>
                            <option value={order.id}><DateFormatView date={order.order_date} /></option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className='col-2 pr-0'>
                      <Field name='promised_date' component={DatePicker} wrapperClasses='mt-1 mb-2 ' label={`Promised Date ${(order.days_until_promised_date || order.days_until_promised_date === 0) ? `(Days left: ${order.days_until_promised_date})` : ''}`} />
                    </div>

                    <OrderInsurancePayer claimFormData={claimFormData} dispatch={dispatch} activeTab={activeTab} />

                    <div className="col-2 pr-0">
                      <div className="form-group mb-0">
                        <label htmlFor="orderinsuranceclaimprovider">
                          Sales Associate
                        </label>
                        <select
                          className="form-control"
                          value={order?.sales_associate_attributes?.id || ""}
                          id="orderinsuranceclaimprovider"
                          onChange={(e) =>
                            handleOrderUpdate({
                              sales_associate_id: e.target.value,
                            })
                          }
                        >
                          <option value="" className="text-muted">
                            Select Provider
                          </option>
                          {allStaff?.map((staff) => (
                            <option key={staff.id} value={staff.id}>
                              {staff.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {(isProcedureExists || showInsuranceFields) &&
                      <div className="col-2 pr-0">
                        <div className="form-group mb-0">
                          <label htmlFor="orderinsuranceclaimprovider">Exam Provider</label>
                          <select className="form-control" value={order?.claim_provider_attributes?.id || ""} id="orderinsuranceclaimprovider" onChange={(e) =>
                            handleOrderUpdate({
                              claim_provider_id: e.target.value,
                            })
                          } >
                            <option value="" className="text-muted">Select Provider</option>
                            {providers.map((provider) =>
                              <option value={provider.id}>{provider.name}</option>
                            )}
                          </select>
                        </div>
                      </div>
                    }

                    <div className='col-2 pr-0'>
                      <label>Prior Auth</label>
                      <div className="dropdown">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-block d-flex align-items-center justify-content-between"
                          data-toggle="dropdown"
                          disabled={order.status === 'finalized' || !(order.orders_insurances_attributes || []).length}
                        >
                          <span>Prior Auth</span>
                          <i className="la la-angle-down" />
                        </button>
                        <div
                          className="dropdown-menu border-0 shadow rounded p-0"
                          style={{ width: '22rem' }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="px-5 pt-5 pb-3 border-bottom">
                            <h6 className="mb-0">Prior Authorization</h6>
                          </div>
                          <div className="px-5 py-4">
                            {(order.orders_insurances_attributes || []).map((insurance, index, list) => (
                              <div key={insurance.id} className={index === list.length - 1 ? 'mb-0' : 'mb-4'}>
                                <label className="d-block small mb-2">{getInsuranceLabel(insurance)}</label>
                                <input
                                  className="form-control form-control-sm"
                                  type="text"
                                  value={priorAuthValues[insurance.id] || ''}
                                  onChange={(e) => handlePriorAuthChange(insurance.id, e.target.value)}
                                  placeholder="Prior Authorization Number"
                                />
                              </div>
                            ))}
                          </div>
                          <div className="px-5 py-4 d-flex justify-content-end border-top bg-light rounded-bottom">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-4"
                              onClick={handlePriorAuthSave}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {showTransactionNumber && (
                      <div className="col-2 pr-0">
                        <Field
                          name="transaction_number"
                          type="text"
                          component={Input}
                          className="form-control"
                          label={
                            isTransactionNumberRequired ? (
                              <>
                                Transaction / Register #
                                <span className="text-danger ml-1">*</span>
                              </>
                            ) : (
                              'Transaction / Register #'
                            )
                          }
                          placeholder="Enter transaction #"
                          disabled={order.status === 'finalized'}
                          wrapperClasses="form-group mb-0"
                        />
                      </div>
                    )}

                    <div className="col-4 pr-0 mt-2">
                      <RPASubmitHistory isOrderView={true} wrapperClasses="px-0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  )
}

OrderHeaderForm = reduxForm({
  form: 'orderHeaderForm',
  enableReinitialize: true,
  onChange: (values, dispatch, props) => {
    if (props.dirty) {
      clearTimeout(timeout);
      timeout = setTimeout(() => props.submit(), 300);
    }
  },
})(OrderHeaderForm);

const mapStateToProps = (state) => {
  const { currentStore, order, staff, patient, auth, setting: { patientTemplate: { patient_template }, template }, organisation: { organisation }, visionInsurance: { services } } = state
  const patientInsuranceData = patient_template.personal_information?.insurance_detail?.fields
  const ordersTemplate = (template?.templates || []).find((t) => t.category === 'orders')
  const transactionNumberConfig = ordersTemplate?.configuration?.transaction_number || {}

  return {
    visionInsuranceTemplate: patientInsuranceData?.vision_insurance?.fields,
    medicalInsuranceTemplate: patientInsuranceData?.medical_insurance?.fields,
    order: order.order,
    patient: patient.patient,
    providers: currentStore.staffs,
    allStaff: staff.staffs,
    selectedOrderId: order.editing && order.editing.id,
    currentUser: auth.user,
    orderStaffId: order.order.staff_id,
    storeDefaultProviderId: currentStore.store.default_provider_id,
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    services,
    transactionNumberConfig,
    initialValues: {
      id: order.order.id,
      staff_id: order.order.staff_id ? order.order.staff_id : currentStore.store.default_provider_id,
      order_date: order.order.order_date,
      promised_date: order.order.promised_date,
      transaction_number: order.order.transaction_number || '',
      self_pay: order.order.self_pay,
      patient_insurance_ids: (() => {
        const ids = order.order.orders_insurances_attributes?.map((orderInsurance) => orderInsurance.patient_insurance_id) || [];
        if (order.order.self_pay) ids.push('self_pay');
        return ids;
      })(),
      orders_insurances_attributes: order.order.orders_insurances_attributes || [],
    }
  }
}

export default connect(mapStateToProps)(OrderHeaderForm);